export default __webpack_public_path__ + "static/badge_hospitality-27aa8d4d2faf737bf649ec407ad7f2ca.png";